/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S1_P3_PostInputs */

const tr_iade_iptal_s1_p3_post = /** @type {(inputs: Iade_Iptal_S1_P3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`'nin ayrılmaz bir ekidir. Hüküm çatışması halinde bu Politika'nın özel hükümleri öncelikle uygulanır.`)
};

const en_iade_iptal_s1_p3_post = /** @type {(inputs: Iade_Iptal_S1_P3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. In the event of conflicting provisions, the special provisions of this Policy prevail.`)
};

const de_iade_iptal_s1_p3_post = /** @type {(inputs: Iade_Iptal_S1_P3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. Im Fall widersprüchlicher Bestimmungen gehen die besonderen Bestimmungen dieser Richtlinie vor.`)
};

const ru_iade_iptal_s1_p3_post = /** @type {(inputs: Iade_Iptal_S1_P3_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`. При противоречии положений преимущественную силу имеют специальные положения настоящей Политики.`)
};

/**
* | output |
* | --- |
* | ". In the event of conflicting provisions, the special provisions of this Policy prevail." |
*
* @param {Iade_Iptal_S1_P3_PostInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s1_p3_post = /** @type {((inputs?: Iade_Iptal_S1_P3_PostInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S1_P3_PostInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s1_p3_post(inputs)
	if (locale === "de") return de_iade_iptal_s1_p3_post(inputs)
	if (locale === "ru") return ru_iade_iptal_s1_p3_post(inputs)
	return tr_iade_iptal_s1_p3_post(inputs)
});